export default __webpack_public_path__ + "static/media/instrucciones-5.ee282d19.jpg";